import { render, staticRenderFns } from "./PostReport.vue?vue&type=template&id=5664b299&lang=pug&"
import script from "./PostReport.vue?vue&type=script&lang=ts&"
export * from "./PostReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports